import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { CSidebar, CSidebarBrand, CSidebarNav, CSidebarToggler } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilX } from '@coreui/icons'
import { AppSidebarNav } from './AppSidebarNav'
import SimpleBar from 'simplebar-react'
import 'simplebar/dist/simplebar.min.css'
 
import { useState, useEffect } from 'react'
import {getModuleDetails}  from '../services/apicalls.js'
import getNav from '../_nav'

const AppSidebar = () => {
  const dispatch = useDispatch()
   const navigation = getNav()

  const [loading, setLoading] = useState(true)
  const unfoldable = useSelector((state) => state.sidebarUnfoldable)
  const sidebarShow = useSelector((state) => state.sidebarShow)
  const [nav, setNav] =useState([])

  return (
    <CSidebar className="app-sidebar" position="fixed" unfoldable={true} visible={sidebarShow} onVisibleChange={(visible) => dispatch({ type: 'set', sidebarShow: visible })}>
      <CSidebarBrand className="d-none d-md-flex " to="/"></CSidebarBrand>
      <button
        type="button"
        className="app-sidebar-close"
        aria-label="Close sidebar"
        onClick={() => dispatch({ type: 'set', sidebarShow: false })}
      >
        <CIcon icon={cilX} size="lg" />
      </button>
      <CSidebarNav>
        <SimpleBar>
          <AppSidebarNav items={navigation} />
        </SimpleBar>
      </CSidebarNav>
      <CSidebarToggler className="d-none d-lg-flex" onClick={() => dispatch({ type: 'set', sidebarUnfoldable: !unfoldable })} />
    </CSidebar>
  )
}

export default React.memo(AppSidebar)
